import { DeparturePortGroupsByContinent } from "@cruisen/contract"
import { SearchDestination } from "@cruisen/react-shared"

export const transformDeparturePortGroups = (data: DeparturePortGroupsByContinent[]) => {
  return data.map((continentGroup) => ({
    label: continentGroup.continent,
    options: continentGroup.groups.map((group) => ({
      value: String(group.id),
      label: group.name,
    })),
  }))
}

export const transformDestinationRegions = (data: SearchDestination[]) => {
  return data.map((region) => ({
    value: String(region.id),
    label: region.name,
  }))
}
